import { useEffect } from "react";
import context from "lib/stores/context";
import apiData from "lib/stores/apiData";
import api from "lib/api";
import { useSnapshot } from "valtio";
import DataPanelWrapper from "./DataPanelWrapper";

export default function ExploreTheDataPanel() {
  const { regions } = useSnapshot(apiData, { sync: true });
  const { activeTabCountries, activeTabRegions, activeRegion, activeCountry, activeView } = useSnapshot(context, { sync: true });

  const renderDataExplorations = () => {
    if (activeView === "region") {
      const region = regions.find(r => {
        return r.id === activeRegion;
      });
      return region.links.map((item: any, i: any) => {
        return <DataExplorationItem item={item} key={i} />;
      });
    }
    return apiData.countries[activeCountry].links.map((item: any, i: any) => {
      return <DataExplorationItem item={item} key={i} />;
    });
  };

  return (
    <DataPanelWrapper className="pt-6" isMounted={() => activeTabCountries === 2 || activeTabRegions === 2}>
      {renderDataExplorations()}
    </DataPanelWrapper>
  );
}

function DataExplorationItem({ item }) {
  return (
    <div className="w-full md:px-0 px-[1.35rem]">
      <button
        className="source mb-6 border-[1px] border-[#000028] px-4 py-3 uppercase text-[#000028] text-[14px] flex items-center justify-between w-full text-left font-[900] hover:text-white hover:bg-black transition-all duration-100 ease-out"
        onClick={() => {
          window.location.hash = item.url;
          window.history.pushState(null, null, window.location.href);
        }}
      >
        <span className="inline-block">{item.caption}</span>
      </button>
    </div>
  );
}
